import { ApiService } from '../../services/api_service';
import { ContextService } from '../../services/context_service';
import { DatenauswertungVsme } from './DatenauswertungVsme';
import { DatenauswertungVsmeReport } from './DatenauswertungVsmeReport';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import breadcrumbStyle from '../start/BreadcrumbNavigation.less';
import { getDefaultHelpIcon, getDefaultHelpIconDatei } from '../../helpers/getDefaultHelpIcon';

interface DatenauswertungVsmeTabProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortTid: number;
    standortName: string;
}

interface DatenauswertungVsmeTabState {
    tabIndex: number;
}

export class DatenauswertungVsmeTab extends React.Component<DatenauswertungVsmeTabProps, DatenauswertungVsmeTabState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxDatenauswertungVsme') ? this.contextService.get('tabIdxDatenauswertungVsme') : 0
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_VSME;
        if (routing.path && routing.path[tabName] !== undefined) {
            // this.setState({ tabIndex: routing.path[tabName] }, () => {
            //     if ((routing.path.terminateOn || null) === tabName) {
            //         this.props.onRoutingChange({});
            //     }
            //     this.contextService.set('tabIdxDatenauswertungVsme', this.state.tabIndex);
            // });
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setState({ tabIndex: routing.path[tabName] }, () => {
                    this.contextService.set('tabIdxDatenauswertungVsme', this.state.tabIndex);
                });
            }
        }
    }

    render(): JSX.Element {
        return (
            <Tabs
                className='tabs-vsme'
                selectedIndex={this.state.tabIndex}
                onSelect={
                    (tabIndex, lastIndex, event) => this.setState(
                        { tabIndex },
                        () => this.contextService.set('tabIdxDatenauswertungVsme', this.state.tabIndex)
                    )
                }
            >
                <TabList style={{ display: 'none' }}>
                    <Tab>Auswertung</Tab>
                    <Tab>Report</Tab>
                </TabList>
                <TabPanel>
                    {getDefaultHelpIcon('datenauswertung_vsme', 'Datenauswertung - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DatenauswertungVsme
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        standortTid={this.props.standortTid}
                        standortName={this.props.standortName}
                    />
                </TabPanel>
                <TabPanel>
                    {getDefaultHelpIcon('datenauswertung_vsme_report', 'Report - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DatenauswertungVsmeReport
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        standortTid={this.props.standortTid}
                        standortName={this.props.standortName}
                    />
                </TabPanel>
            </Tabs>
        );
    }
}
